export const iconFontAwesomeAnimalsCat = (
	<i className="fa-solid fa-cat"></i>
);
